var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "contacts-item-block" } },
    [
      _vm.contact.department_name
        ? _c(
            "h2",
            {
              staticClass: "text-h6 text--text mt-0",
              class: _setup.isMobile ? "mb-4" : "mb-3",
              attrs: { "data-qa": "contacts-item-title" },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _setup.transDynamic(
                      _vm.contact,
                      `department_name,${_setup.language},${_setup.needTranslate}`
                    )
                  ) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contact.work_start_time && _vm.contact.work_end_time
        ? _c(
            "p",
            {
              staticClass: "text-body-1 text-secondary--text",
              class: _setup.isMobile ? "mb-4" : "mb-3",
              attrs: { "data-qa": "contacts-item-time" },
            },
            [
              _vm.contact.work_start_time === _vm.contact.work_end_time
                ? [
                    _vm._v(
                      "\n      " +
                        _vm._s(_setup.t("Круглосуточно", _setup.options)) +
                        "\n    "
                    ),
                  ]
                : [
                    _c("time", [
                      _vm._v(
                        _vm._s(
                          _setup.formattedTime(_vm.contact.work_start_time)
                        )
                      ),
                    ]),
                    _vm._v(" —\n      "),
                    _c("time", [
                      _vm._v(
                        _vm._s(_setup.formattedTime(_vm.contact.work_end_time))
                      ),
                    ]),
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _setup.transDynamic(
                            _vm.contact,
                            `timezone_text,${_setup.language},${_setup.needTranslate}`
                          )
                        ) +
                        "\n    "
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contact.email
        ? _c(
            "a",
            {
              staticClass: "text-body-1 link-decoration-none primary--text",
              class: _setup.isMobile ? "d-table mb-4" : "d-inline-flex mb-3",
              attrs: {
                "data-qa": "contacts-item-email",
                href: `mailto:${_vm.contact.email}`,
              },
            },
            [_vm._v(_vm._s(_vm.contact.email))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.ContactsPhones, { attrs: { phones: _vm.contact.phones.all } }),
      _vm._v(" "),
      _vm.contact.messengers.all.length
        ? _c(_setup.ContactsMessengers, {
            attrs: { messengers: _vm.contact.messengers.all },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }